import { prop } from '@ipfabric/utils/fp/prop';
import { useGraphContextSelectors } from 'components/Graph/GraphContext';
import type { FC } from 'react';

export const EmptyGraphReason: FC = () => {
  const { emptyGraphReason } = useGraphContextSelectors({
    emptyGraphReason: prop('emptyGraphReason'),
  });
  return (
    <p className='text-bold text-uppercase text-danger'>
      <i className='fa fa-exclamation-circle mr-2.5' />
      {emptyGraphReason}
    </p>
  );
};
